module.exports = __webpack_public_path__ + "static/img/5.dc999df.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/5.gif
// module id = Yp39
// module chunks = 1